'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { css, useTheme } from 'styled-components';
import { getButtonColorStyling, getLinkStyling, getTransparentStyling, } from './styles';
const styleToCss = (style) => css(Object.assign({}, style));
const DEFAULT_BUTTON_SIZE = 'small';
const isMedia = (query) => {
    return typeof window !== 'undefined' && window.matchMedia(query).matches;
};
const useButtonProps = (props) => {
    const theme = useTheme();
    return useMemo(() => {
        const currentProps = {};
        const prepareProps = (data, query) => {
            var _a, _b, _c;
            if (!!data && Object.keys(data).length) {
                const { fitContent, fullWidth, isLink, transparent, textWrap, defaultStyle, hidden, style, } = data;
                const buttonProps = {
                    theme,
                    size: (_a = props.size) !== null && _a !== void 0 ? _a : DEFAULT_BUTTON_SIZE,
                    defaultTheme: defaultStyle !== null && defaultStyle !== void 0 ? defaultStyle : '',
                    withArrow: !!props.withArrowLeft || !!props.withArrowRight,
                    shape: (_b = props.shape) !== null && _b !== void 0 ? _b : 'rounded',
                    variant: props.variant,
                };
                if (fitContent) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]};
            width: fit-content;
            min-width: 0;
          `;
                }
                if (fullWidth) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]};
            width: 100%;
            min-width: 0;
          `;
                }
                if (textWrap) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]};
            white-space: normal;
          `;
                }
                if (hidden) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]};
            display: none;
          `;
                }
                if (transparent) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]}
            ${getTransparentStyling(buttonProps)}
          `;
                }
                else if (isLink) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]}
            ${getLinkStyling(buttonProps)}
          `;
                }
                else if (query === 'default') {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]}
            ${getButtonColorStyling(Object.assign(Object.assign({}, buttonProps), { defaultTheme: (_c = buttonProps.defaultTheme) !== null && _c !== void 0 ? _c : theme.colors.purple_1 }))}
          `;
                }
                if (style) {
                    currentProps[`$${query}`] = css `
            ${currentProps[`$${query}`]}
            ${styleToCss(style)}
          `;
                }
            }
        };
        const handleClick = (e) => {
            var _a, _b, _c, _d, _e, _f;
            e.stopPropagation();
            e.preventDefault();
            const defaultClick = () => props.onClick && props.onClick(e);
            if (isMedia(`(min-width: ${theme.breakpoints.xl}px)`)) {
                (_c = ((_b = (_a = props.xl) === null || _a === void 0 ? void 0 : _a.onClick) !== null && _b !== void 0 ? _b : defaultClick)) === null || _c === void 0 ? void 0 : _c(e);
            }
            else if (`(min-width: ${theme.breakpoints.tablet}px)`) {
                (_f = ((_e = (_d = props.tablet) === null || _d === void 0 ? void 0 : _d.onClick) !== null && _e !== void 0 ? _e : defaultClick)) === null || _f === void 0 ? void 0 : _f(e);
            }
            else {
                defaultClick();
            }
        };
        const { children, id, className, headingIcon, trailingIcon, withArrowLeft, withArrowRight, size, loading, disabled, xl, tablet, onMouseEnter, onMouseLeave, onPointerEnter, onPointerLeave, shape = 'rounded-corner' } = props, buttonProps = __rest(props, ["children", "id", "className", "headingIcon", "trailingIcon", "withArrowLeft", "withArrowRight", "size", "loading", "disabled", "xl", "tablet", "onMouseEnter", "onMouseLeave", "onPointerEnter", "onPointerLeave", "shape"]);
        const defaultProps = {
            children,
            id,
            className,
            headingIcon,
            trailingIcon,
            withArrowLeft,
            withArrowRight,
            disabled,
            size: size !== null && size !== void 0 ? size : DEFAULT_BUTTON_SIZE,
            loading,
            handleClick,
            onMouseEnter,
            onMouseLeave,
            onPointerEnter,
            onPointerLeave,
            shape,
        };
        prepareProps(buttonProps, 'default');
        prepareProps(xl, 'xl');
        prepareProps(tablet, 'xl');
        return { currentProps, defaultProps };
    }, [props, theme]);
};
export default useButtonProps;
